
import {RowType,ITableDataProps} from '../../../Component/Model/Table/SummaryTable';

export function MapToEEA4TableData(dataObject: any[]): ITableDataProps {

        var bodyData = dataObject.filter((item) => item.rowType === RowType.body);
        var footerData = dataObject.filter((item) => item.rowType === RowType.footer);
        return {
            head: [
                {
                    heading: 'Occupational Levels',
                    attribute: 'rowLabel',
                    thClass: 'rowLabel'
                },
                {
                    heading: '',
                    attribute: 'label',
                    thClass: 'nestedLabel'
                },
                {
                    heading: 'African Males',
                    attribute: 'africanMales',
                },
                {
                    heading: 'African Females',
                    attribute: 'africanFemales'
                },
                {
                    heading: 'Coloured Males',
                    attribute: 'colouredMales'
                },
                {
                    heading: 'Coloured Females',
                    attribute: 'colouredFemales'
                },
                {
                    heading: 'Indian Males',
                    attribute: 'indianMales'
                },
                {
                    heading: 'Indian Females',
                    attribute: 'indianFemales'
                },
                {
                    heading: 'White Males',
                    attribute: 'whiteMales'
                },
                {
                    heading: 'White Females',
                    attribute: 'whiteFemales'
                },
                {
                    heading: 'Foreign National Males',
                    attribute: 'nonSAMales'
                },
                {
                    heading: 'Foreign National Females',
                    attribute: 'nonSAFemales'
                },
                {
                    heading: 'Totals',
                    attribute: 'total'
                },

            ],
            body: bodyData,
            foot: footerData,
            footClass: 'darkbackground',
        };
    }
